import { common } from './common';
import { homepage } from './homepage';
import { about } from './about';
import { outputs } from './outputs';
import { services } from './services';
import { contact } from './contact';
import { legal } from './legal';

export const ui = {
	...common,
	...homepage,
	...about,
	...outputs,
	...services,
	...contact,
	...legal,
} as const;
